import React, { CSSProperties } from 'react';
import {
  Column,
  Container,
  Copy,
  Heading,
  Row,
  Stack,
} from '@grubhubprod/gh-cookbook-react/dist';
import {
  Breakpoint,
  useDeviceSize,
} from '@grubhubprod/umami-library/dist/hooks/useDeviceSize';
import { OnboardingCard } from 'src/components/selfService/features/Signup/steps/LineOfCreditStep/OnboardingCard';
import { getWindow } from 'src/utilities/window';
import { onboardingCardDetails } from 'src/components/selfService/features/Signup/steps/LineOfCreditStep/LineOfCreditStep.constants';
import { getOnboardingCardColumnStyle } from 'src/components/selfService/features/Signup/steps/LineOfCreditStep/LineOfCreditStep.utils';

interface OnboardingSectionProps {
  style: CSSProperties;
}

export function OnboardingSection({
  style,
}: OnboardingSectionProps): JSX.Element {
  const { breakpoint } = useDeviceSize(getWindow());

  const isMobile = breakpoint < Breakpoint.sm;
  const isTablet = breakpoint >= Breakpoint.sm && breakpoint < Breakpoint.lg;

  return (
    <div style={style}>
      <Stack y={isMobile ? 'md' : 'xx-lg'}>
        <Container variant="sm">
          <Stack y="x-sm">
            <Heading variant="h1" textAlign={isMobile ? 'left' : 'center'}>
              Ready to create meal credits?
            </Heading>
          </Stack>
          <Copy
            variant="body"
            textAlign={isMobile ? 'left' : 'center'}
            display="block"
          >
            You can create meal credits now or skip this step and come back to
            it later
          </Copy>
        </Container>
      </Stack>
      <Row gutter={0}>
        {onboardingCardDetails.map((cardDetails, index) => (
          <Column
            key={`${cardDetails.primaryText}-${cardDetails.secondaryText}`}
            tablet={4}
            gutter={0}
            style={getOnboardingCardColumnStyle(isMobile, isTablet)}
          >
            <OnboardingCard
              onboardingCardDetails={cardDetails}
              isLastCard={index === onboardingCardDetails.length - 1}
            />
          </Column>
        ))}
      </Row>
    </div>
  );
}
